import React, { Component, Fragment } from "react";
import {
  Button,
  DialogActions,
  DialogContent,
  FormControl,
  InputLabel,
  FormHelperText,
  Input,
  Grid
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { compose } from "redux";
import { withFormik } from "formik";
import Modal from "components/Modal";
import { connect } from "react-redux";
import { getContact, changePassword, resetPassword } from "store/state/contacts";
import { isEmpty } from "lodash";
import { validatePasswordForCognitoRequirements } from "lib/helper";

class ResetPassword extends Component {
  state = {
    newPassword: "",
    newPasswordError: "",
    newPasswordConfirm: "",
    newPasswordConfirmError: "",
    touched: false
  };

  componentDidMount() {
    const { match } = this.props;

    if (
      !this.props.contact ||
      match.params.contactId !== this.props.contact.contact.id.toString()
    ) {
      this.props.getContact({ id: match.params.contactId });
    }
  }

  handleClose = () => {
    this.props.history.push(`/admin/contacts`);
  };

  validation = () => {
    const errors = { newPasswordError: "", newPasswordConfirmError: "" };

    if (!this.state.newPassword) {
      errors.newPasswordError = "Missing entry";
    } else if (!validatePasswordForCognitoRequirements(this.state.newPassword)) {
      errors.newPasswordError = "The password is not strong enough";
    } else if (
      this.state.newPassword !== this.state.newPasswordConfirm
    ) {
      errors.newPasswordConfirmError = "Passwords do not match";
    }

    this.setState(errors);
  };

  handleChange = ({ target: { name, value } }) => {
    this.setState(
      {
        [name]: value,
        touched: true
      },
      () => {
        this.validation();
      }
    );
  };

  handleSave = () => {
    const { contact } = this.props.contact;

    const payload = {
      oldPassword: contact.user.password,
      newPassword: this.state.newPassword,
      name: contact.fullName
    };

    this.props.changePassword({ payload, id: contact.userId });
    this.props.history.push(`/admin/contacts`);
  };

  render() {
    const { match, contact } = this.props;
    const {
      newPassword,
      newPasswordError,
      newPasswordConfirm,
      newPasswordConfirmError,
      touched
    } = this.state;

    if (
      isEmpty(contact) ||
      match.params.contactId !== this.props.contact.contact.id.toString()
    ) {
      return null;
    }

    return (
      <Fragment>
        <Modal
          hideModal={this.handleClose}
          open
          modalTitle="Change Password"
          className="resetPassword"
        >
          <DialogContent style={{ maxWidth: "500px" }}>
            <Grid container spacing={24}>
              <Grid item xs={12}>
                <Typography variant="title">
                  Please remember to inform the user of their new password after
                  you change it.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                User Name:
                {contact.contact.user ? contact.contact.user.email : "Not Set"}
              </Grid>
              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  margin="normal"
                  error={newPasswordError}
                >
                  <InputLabel htmlFor="newPassword">New Password *</InputLabel>
                  <Input
                    type="text"
                    name="newPassword"
                    defaultValue={newPassword}
                    onChange={this.handleChange}
                  />
                  {newPasswordError && (
                    <FormHelperText>{newPasswordError}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl
                  fullWidth
                  margin="normal"
                  error={newPasswordConfirmError}
                >
                  <InputLabel htmlFor="newPasswordConfirm">
                    Confirm New Password *
                  </InputLabel>
                  <Input
                    type="text"
                    name="newPasswordConfirm"
                    defaultValue={newPasswordConfirm}
                    onChange={this.handleChange}
                  />
                  {newPasswordConfirmError && (
                    <FormHelperText>{newPasswordConfirmError}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              disabled={!touched || newPasswordError || newPasswordConfirmError}
              onClick={this.handleSave}
              type="submit"
            >
              Save
            </Button>
            <Button onClick={this.handleClose}>Cancel</Button>
          </DialogActions>
        </Modal>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ loading, authentication, contacts }) => ({
  loading,
  authentication,
  contact: contacts.contact
});

export default compose(
  connect(
    mapStateToProps,
    { getContact, changePassword, resetPassword }
  ),
  withFormik({
    mapPropsToValues: props => (props.contact ? props.contact.contact : ""),
    enableReinitialize: true,
    displayName: "ChangePassword"
  })
)(ResetPassword);
